export const OBSERVED_PATIENT_KEY_NAME = 'observedPatient'
